// import * as XLSX from 'xlsx';
import * as XLSX from 'xlsx-js-style';

import { saveAs } from 'file-saver';
// import axios from 'axios';

export const GeneraExcel_v1 = async (questCorrente) => {
  console.log('questCorrente: ', questCorrente);
 
  function nomeEsteso(key) {
    const pair = questCorrente.stakeholders.find(pair => pair.id === key);
    return pair ? pair.alias.toUpperCase() : null;
  }

    // INIZIO GESTIONE FILE XLSX
    // Crea un nuovo workbook
    const workbook = XLSX.utils.book_new();

    const separator = '-'
    let newDate = new Date()
    let date = newDate.getDate()
    let month = newDate.getMonth() + 1
    let year = newDate.getFullYear()
    let hours = ((newDate.getHours() < 10)?"0":"") + newDate.getHours() 
    let minutes = ((newDate.getMinutes() < 10)?"0":"") + newDate.getMinutes()
       
    const now = `${date}${separator}${month<10?`0${month}`:`${month}`}${separator}${year} ${hours}:${minutes}`

    const outputFileName = `CSVC Riepilogo-dati-input ${year}-${month<10?`0${month}`:`${month}`}-${date}_${hours}-${minutes}.xlsx`
    questCorrente.ambiti.forEach((ambito) => {
      if (ambito.enabled){
        let ambitoCorrente = ambito.key
        let eri = ''
        let rilevanza = ''
        let kpiKeyToFind = ''
        let kpiCorrente = {}
        let rilevanzaAmbitoCorrente = questCorrente.rilevanzaAmbiti.find(item => item.ambito === ambitoCorrente);
        const sheet1Data = []
    
        sheet1Data.push([{ v: "METODO CSVC (CVSA) - RIEPILOGO DEI DATI IN INPUT", t: "s", s: { font: { bold: true, sz: 14 } } }   ])
        sheet1Data.push([])
        sheet1Data.push(["Azienda: ", { v: questCorrente.aziendaNome, t: "s", s: { font: { bold: true, sz: 14} } }   ])
        sheet1Data.push([])
        sheet1Data.push([{ v: 'Elaborazione del '+ now, t: "s", s: { font: { italic: true} } }   ])
        sheet1Data.push(['##############################################################################################'])
        sheet1Data.push([{ v: ambito.key + ' - ' +  ambito.descrizione, t: "s", s: { font: { bold: true, sz: 14, color: { rgb: "0000FF" } } } }])
        ambito.ricadute.forEach((ricaduta) => {
          sheet1Data.push(['# =========================================================================================== #'])
          sheet1Data.push(["Ricaduta "+ricaduta.codiceCsvc, ricaduta.effetto + '(' +  ricaduta.tipo + ')'])

          eri = (ricaduta.effetto==='INSIDE-OUT')?rilevanzaAmbitoCorrente.ioEri:rilevanzaAmbitoCorrente.oiEri
          rilevanza = (ricaduta.effetto==='INSIDE-OUT')?rilevanzaAmbitoCorrente.io:rilevanzaAmbitoCorrente.oi

          ricaduta.impatti.forEach((impatto) => {   // In questa versione del questionario, ogni ricaduta ha uno e un solo impatto (alias rischio)
            sheet1Data.push([ 'Rischio '+impatto.codiceCsvc , { v: impatto.descrizione, t: "s", s: { font: { bold: true, color: { rgb: "FF0000" } } } }  ])
            sheet1Data.push(["","ERI: ", { v: eri, t: "s", s: { alignment: { wrapText: true } } } ])
            sheet1Data.push(["","Rilevanza: ", { v:   
              ((rilevanza==10) ? 'Bassa' :
              (rilevanza==30) ? 'Moderata' :
              (rilevanza==50) ? 'Media' :
              (rilevanza==70) ? 'Alta' :
              (rilevanza==90) ? 'Molto alta':
              ''), 
              t: "s", s: { font: { bold: true, color: { rgb: "FF0000" } } } }
            ])
            sheet1Data.push([])


            impatto.azioni.forEach((azione) => {
              if (azione.enabled) {
                sheet1Data.push(['', '# ------------------------------------------------------------------------------------------------------------------------- #'])

                sheet1Data.push([{ v: ">>>>>", t: "s", s: { font: { bold: true, color: { rgb: "0000FF" } } } }, { v: ambitoCorrente + " - AZIONE " + azione.item +' (KPI'+azione.item+') - ' + azione.codiceCsvc + ' - ' + azione.descrizione, t: "s", s: { font: { bold: true, color: { rgb: "0000FF" } } } } ])
                kpiKeyToFind = azione.kpis[0].stakholderOpportunita[0].key  // In questa versione del questionario, ogni azione ha uno e un solo kpi 
                                                                            // Ogni kpi contiene: opportunità per stakeholder - array di un elemento)
                                                                            // opportunità per azienda, array di tre elementi 
                sheet1Data.push([""])
                sheet1Data.push(["", "OPPORTUNITA PER STAKEHOLDER (" + azione.kpis[0].stakholderOpportunita[0].codiceCsvc + ")"])

                  // I valori dei kpi sono contenuti in un diverso array questCorrente.kpis dove cercare l'elemento con codice kpiKey
                  kpiCorrente = questCorrente.kpis.find(item => item.kpiKey === kpiKeyToFind);
                  if (!kpiCorrente || Object.keys(kpiCorrente).length === 0) {
                    sheet1Data.push(["", "", { v:  kpiKeyToFind + " NON TROVATO", t: "s", s: { font: { bold: true, color: { rgb: "FF0000" } }, fill: { patternType: "solid", fgColor: { rgb: "FFFF00" } } }  } ])  // Solo per debug
                  } else {
                    sheet1Data.push(["", 'Stakeholder impattato: ' + nomeEsteso(kpiCorrente.stakeholder)])
                    sheet1Data.push(["", { v: kpiCorrente.descrizione, t: "s", s: { font: { bold: true} } } ])
                    sheet1Data.push(["", questCorrente.perCorr, { v: kpiCorrente.perCorrGiust, t: "s", s: { alignment: { wrapText: true } } }, { v: kpiCorrente.perCorrValore, t: "n", s: { alignment: { horizontal: 'right' }, font: { bold: true} } } ])
                  }    
                sheet1Data.push([""])
                sheet1Data.push(["", "OPPORTUNITA PER L'AZIENDA (" + azione.kpis[0].bilancioPoste[0].codiceCsvc + ")"])
                kpiKeyToFind = azione.kpis[0].bilancioPoste[0].key

                  // I valori dei kpi sono contenuti in un diverso array questCorrente.kpis dove cercare l'elemento con codice kpiKey
                  kpiCorrente = questCorrente.kpis.find(item => item.kpiKey === kpiKeyToFind);
                  if (!kpiCorrente || Object.keys(kpiCorrente).length === 0) {
                    sheet1Data.push(["", "", { v:  kpiKeyToFind + " NON TROVATO", t: "s", s: { font: { bold: true, color: { rgb: "FF0000" } }, fill: { patternType: "solid", fgColor: { rgb: "FFFF00" } } }  } ])  // Solo per debug
                  } else {
                    sheet1Data.push(["", 'Sottoconto ' + kpiCorrente.sottoconto])
                    sheet1Data.push(["", { v: kpiCorrente.descrizione, t: "s", s: { font: { bold: true} } } ])
                    sheet1Data.push(["", questCorrente.perPrec, { v: kpiCorrente.perPrecGiust, t: "s", s: { alignment: { wrapText: true } } }, kpiCorrente.perPrecValore])
                    sheet1Data.push(["", questCorrente.perCorr, { v: kpiCorrente.perCorrGiust, t: "s", s: { alignment: { wrapText: true } } }, { v: kpiCorrente.perCorrValore, t: "n", s: { alignment: { horizontal: 'right' }, font: { bold: true} } }])
                    sheet1Data.push(["", questCorrente.perSucc, { v: kpiCorrente.perSuccGiust, t: "s", s: { alignment: { wrapText: true } } }, kpiCorrente.perSuccValore])
                  }    

                sheet1Data.push([""])
                sheet1Data.push(["", "COSTI (" + azione.kpis[0].bilancioPoste[1].codiceCsvc + ")"])
                kpiKeyToFind = azione.kpis[0].bilancioPoste[1].key
                // sheet1Data.push(["", kpiKeyToFind ])  // Solo per debug

                  // I valori dei kpi sono contenuti in un diverso array questCorrente.kpis dove cercare l'elemento con codice kpiKey
                  kpiCorrente = questCorrente.kpis.find(item => item.kpiKey === kpiKeyToFind);
                  if (!kpiCorrente || Object.keys(kpiCorrente).length === 0) {
                    sheet1Data.push(["", "", { v:  kpiKeyToFind + " NON TROVATO", t: "s", s: { font: { bold: true, color: { rgb: "FF0000" } }, fill: { patternType: "solid", fgColor: { rgb: "FFFF00" } } }  } ])  // Solo per debug
                  } else {
                    sheet1Data.push(["", 'Sottoconto ' + kpiCorrente.sottoconto])
                    sheet1Data.push(["", { v: kpiCorrente.descrizione, t: "s", s: { font: { bold: true} } }])
                    sheet1Data.push(["", questCorrente.perCorr, { v: kpiCorrente.perCorrGiust, t: "s", s: { alignment: { wrapText: true } } }, { v: kpiCorrente.perCorrValore, t: "n", s: { alignment: { horizontal: 'right' }, font: { bold: true} } }])
                  }    
    
                sheet1Data.push([""])
                sheet1Data.push(["", "CONTRIBUTI (" + azione.kpis[0].bilancioPoste[2].codiceCsvc + ")"])
                kpiKeyToFind = azione.kpis[0].bilancioPoste[2].key
                // sheet1Data.push(["", kpiKeyToFind ])  // Solo per debug

                  // I valori dei kpi sono contenuti in un diverso array questCorrente.kpis dove cercare l'elemento con codice kpiKey
                  kpiCorrente = questCorrente.kpis.find(item => item.kpiKey === kpiKeyToFind);
                  if (!kpiCorrente || Object.keys(kpiCorrente).length === 0) {
                    sheet1Data.push(["", "", { v:  kpiKeyToFind + " NON TROVATO", t: "s", s: { font: { bold: true, color: { rgb: "FF0000" } }, fill: { patternType: "solid", fgColor: { rgb: "FFFF00" } } }  } ])  // Solo per debug
                  } else {
                    sheet1Data.push(["", 'Sottoconto ' + kpiCorrente.sottoconto])
                    sheet1Data.push(["", { v: kpiCorrente.descrizione, t: "s", s: { font: { bold: true} } }])
                    sheet1Data.push(["", questCorrente.perCorr, { v: kpiCorrente.perCorrGiust, t: "s", s: { alignment: { wrapText: true } } }, { v: kpiCorrente.perCorrValore, t: "n", s: { alignment: { horizontal: 'right' }, font: { bold: true} } }])
                  }    
    
                sheet1Data.push([])
              }
            })  
            sheet1Data.push([])
          })
          sheet1Data.push([])
        })
        // Creo il Foglio e lo aggiungo alla cartella Excel

        // Crea un nuovo foglio di lavoro vuoto
        const sheet1 = XLSX.utils.aoa_to_sheet([]);
        
        // Aggiungi i dati al foglio di lavoro
        XLSX.utils.sheet_add_aoa(sheet1, sheet1Data, { origin: 'A1' });

        // Aggiungo larghezza colonne
        sheet1['!cols'] = [{ wch: 10 }, { wch: 10 }, { wch: 80 } , { wch: 10 }]; 


        XLSX.utils.book_append_sheet(workbook, sheet1, ambitoCorrente);

      }
    })

    // Genera il file Excel e consenti il download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, outputFileName);

};

/*
  // ====================================================================================
  //
  //  Esempio 2
  //
  export const GeneraExcel_v2 = async () => {
    const questCorrente = useSelector(
      (state) => state.questCorrente
    );
  
    console.log('questCorrente: ', questCorrente);
    
    // INIZIO GESTIONE FILE XLSX
  
  // Scarica il file Excel dal server
      const response = await axios.get('/assets/xlsx/templateRiepilogoDatiInput_v01.xlsx', { responseType: 'arraybuffer' });
      const data = new Uint8Array(response.data);
      const workbook = XLSX.read(data, { type: 'array' });
   

      // Modifica il primo foglio
      const sheet1 = workbook.Sheets[workbook.SheetNames[0]];
      const newData = [
        ["Nome", "Età"],
        ["Mario", 30],
        ["Luigi", 25]
      ];
      XLSX.utils.sheet_add_aoa(sheet1, newData, { origin: -1 });

      // Genera il file Excel modificato e consenti il download
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      saveAs(blob, 'modified_example.xlsx');

    // FINE GESTIONE FILE XLSX

    };
*/


/*
  // VISUALIZZAZIONE DEI CRITERI DI CALCOLO CON TESTO A CAPO:

  import { TextWithLineBreaks } from '../components-csvc/TextWithLineBreaks'
  <td align="left"><TextWithLineBreaks text={kpi.perCorrGiust} /></td>



  
          <div>
            <button onClick={handleDownload}>Esporta file .xlsx con riepilogo dati in input</button>
          </div>



*/
